import script from "./APIKeys.vue?vue&type=script&setup=true&lang=js"
export * from "./APIKeys.vue?vue&type=script&setup=true&lang=js"

import "./APIKeys.vue?vue&type=style&index=0&id=373fde16&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-373fde16"]])

export default __exports__